import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Grid,
  Typography,
  Divider,
  LinearProgress,
  styled,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setProdcuctName,
  setSelectedIndex,
} from "../../../services/redux/slices/tabsSlice";
import { setSelectedloanAccountNumber } from "../../../services/redux/slices/optionSlice";
import { setloanAccountNumberOptions } from "../../../services/redux/slices/optionSlice";
import { Box, spacing, useMediaQuery, useTheme } from "@mui/system";
import {
  formatIndianRupees,
  handlePercentAmount,
  checkPercentage,
} from "../../../utils/formatting";
import queryString from "query-string";
import {
  setDashboardData,
  setExistDisbursementStatus,
  setSelectedLoanNumber,
} from "../../../services/redux/slices/dashboardDataSlice";
import { ROUTES } from "../../../routes/routerConfig";
import {
  authSelector,
  userLoanCatSelector,
} from "../../../services/redux/slices/authSlice";
import InfoIcon from "../../../assets/images/icons/info.png";

import {
  setStatusPopup,
  statusPopupSelector,
} from "../../../services/redux/slices/statusPopupSlice";
import { messages } from "../../../data/constant";
import { termLoanPermissionCheck } from "../../../utils/helpers";
import { cleardisbursementButtonSlice } from "../../../services/redux/slices/disbursementButtonSlice";
import { encrypt } from "../../../utils/crypto";
import Card from "../../../components/ui/Card";
import { OutlinedSmallButton } from "../../../components/ui/Button";
import Skeleton from "@mui/material/Skeleton";
import postsServices from "../../../services/api/service/postsService";
import { RootState } from "../../../services/redux/store";
import { setaccountSummaryData } from "../../../services/redux/slices/accountSummarySlice";
import service from "../../../services/api/service";
import { formatDate } from "../../../utils/dateFormatUtils";
import UtilizedIcon from "../../../assets/images/icons/utilized.png";
import AvailableIcon from "../../../assets/images/icons/available.png";
import AccountSelectorDropDown from "../../../components/ui/AccountSelectorDropDown";

interface QueryParams {
  lan: string | null;
  business: string | null;
  loanCategory: string | null;
}

interface CoBorrower {
  cif: string;
  shortName: string;
}

const AccountSummaryTerm = () => {
  const [accountSummaryData, setAccountSummaryData] = useState<any[]>([]);
  const { userProfile, businessType } = useSelector(authSelector);
  const [accountNumber, setAccountNumber] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const selectedIndex = useSelector(
    (state: RootState) => state?.tabs?.selectedIndex
  );
  const [moratStatus, setMoratStatus] = useState(false);
  const navigate = useNavigate();
  const { refreshValue } = useSelector(statusPopupSelector);
  const userLoanCategory = useSelector(userLoanCatSelector);
  const [selected, setSelected] = useState("termLoan");
  const initialFetch = useRef(true);

  const handleChangeToggle = (event: any, newSelection: any) => {
    if (newSelection !== null) {
      setSelected(newSelection);
    }
  };
  const selectedLoanNumber = useSelector(
    (state: RootState) => state?.dashboardData?.selectedLoanNumber
  );
  const dasboardDataSet = useSelector(
    (state: RootState) => state?.dashboardData
  );
  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.existMoratStatus
  );

  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );

  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );


  const fetchData = async () => {
    setIsLoading(true);
    const queryParams: QueryParams = { lan: selectedLoanNumber, business: businessTypeId, loanCategory: loanCategoryData?.TermLoan[0]?.loanCategoryId };
    const queryParamsString = queryString.stringify(queryParams);
    try {
      const response = await service.posts.getPosts(
        `api/v1/dashboard/term-account-summary?${queryParamsString}`
      );
      const data = response?.data?.data || [];
      setAccountNumber(data[0]?.lanNumber);
      setAccountSummaryData(data);
      dispatch(setaccountSummaryData(data));
      // Adding the filter logic here
      const status = dasboardDataSet.sanctionedDisbursedData
        .filter(
          (dataItem: { lanNumber: string }) =>
            dataItem.lanNumber === selectedLoanNumber
        )
        .map((dataItem: { morat: boolean }) => dataItem.morat)[0];
      setMoratStatus(!!status);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedLoanNumber]);

  const dispatch = useDispatch();

  const handleViewDetailsClick = (
    loanAccountNumber: any,
    isExistDisbursementAllowdLoan: any
  ) => {
    if (termLoanPermissionCheck()) {
      let filterLoanAccountNumber = accountSummaryData?.map(
        (acc) => acc.lanNumber
      );
      dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
      //dispatch(setSelectedloanAccountNumber(loanAccountNumber));
      dispatch(setDashboardData(accountSummaryData));
      dispatch(setExistDisbursementStatus(isExistDisbursementAllowdLoan));
      //dispatch(setSelectedLoanNumber(loanAccountNumber));
      navigate(ROUTES?.Dashboard?.termLoanPage?.locationPath);
      dispatch(setSelectedIndex(0));
      dispatch(setProdcuctName("TermLoan"));
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message: `${messages.noPermission.module} "Account Summary"`,
        })
      );
    }
  };

  const requestForDisbursement = (
    loanAccountNumber: any,
    isExistDisbursementAllowdLoan: any
  ) => {
    if (isExistDisbursementAllowdLoan === true) {
      if (termLoanPermissionCheck()) {
        let filterLoanAccountNumber = accountSummaryData?.map(
          (acc: any) => acc.lanNumber
        );
        dispatch(cleardisbursementButtonSlice());
        dispatch(setloanAccountNumberOptions(filterLoanAccountNumber));
        //dispatch(setSelectedloanAccountNumber(loanAccountNumber));
        dispatch(setDashboardData(accountSummaryData));
        //dispatch(setSelectedLoanNumber(loanAccountNumber));
        navigate(ROUTES?.Dashboard?.termLoanPage?.locationPath);
        dispatch(setSelectedIndex(0));
        dispatch(setProdcuctName("TermLoan"));
      } else {
        dispatch(
          setStatusPopup({
            status: "no access",
            message: `${messages.noPermission.module} "Account Summary"`,
          })
        );
      }
    } else {
      dispatch(
        setStatusPopup({
          status: "no access",
          message:
            "Disbursement requests are currently unavailable for this loan",
        })
      );
    }
  };

  const MultiColorProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: "rgba(22, 135, 148, 1)",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)",
    },
  }));

  const MultiColorProgressBarMobile = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: "5px",
    backgroundColor: "rgba(22, 135, 148, 1)", // Available background
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)", // Utilized color
    },
  }));
  let spacing = 4;
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  if (isXsOrSm) {
    spacing = 0;
  }
  const LoanCardSkeleton = () => {
    return (
      <Box sx={{ padding: "20px", marginBottom: "20px" }}>
        <Grid container>
          <Grid item xs={12} sm={8}>
            <Skeleton variant="rectangular" width="100%" height={30} />
            <Skeleton variant="rectangular" width="70%" height={20} />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Skeleton variant="rectangular" width={120} height={35} />
          </Grid>
        </Grid>
        <Divider sx={{ margin: "20px 0" }} />
        <Grid container spacing={2}>
          {[...Array(6)].map((_, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Skeleton variant="rectangular" width="100%" height={20} />
              <Skeleton variant="rectangular" width="80%" height={15} />
            </Grid>
          ))}
        </Grid>
        <Divider sx={{ margin: "20px 0" }} />
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Skeleton variant="rectangular" width="100%" height={20} />
            <Skeleton variant="rectangular" width="80%" height={15} />
            <Skeleton variant="rectangular" width="60%" height={10} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Skeleton variant="rectangular" width="100%" height={20} />
            <Skeleton variant="rectangular" width="80%" height={15} />
            <Skeleton variant="rectangular" width="60%" height={10} />
          </Grid>
        </Grid>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={10}
          sx={{ marginTop: "10px" }}
        />
      </Box>
    );
  };

  return (
    <React.Fragment>
      <Grid container className="mt-20 account-summary-term">
        {isLoading ? (
          <>
            {[1, 2, 3, 4, 5].map((item, index) => (
              <Card key={index}>
                <LoanCardSkeleton />
              </Card>
            ))}
          </>
        ) : (
          <>
            <Card borderColor={true} marginBottom="20px">
              {!isXsOrSm && (
                <>
                  <Grid container sm>
                    <Grid item sm={8} sx={{ height: "28px" }}>
                      <Typography
                        className="loan-account-main-heading"
                        style={{ marginBottom: "5px" }}
                      >
                        Loan A/C {accountNumber}
                      </Typography>

                      <Typography className="loan-account-sub-heading">
                        {accountSummaryData[0]?.description}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container sm sx={{ paddingTop: "30px" }}>
                    <Grid item sm={12}>
                      <Divider
                        sx={{
                          border: isXsOrSm
                            ? ""
                            : "1px solid rgba(219, 218, 222, 1)",
                          borderColor: isXsOrSm ? "rgba(0, 0, 0, 0.12)" : "",
                          borderBottomWidth: isXsOrSm ? "thin" : "",
                          width: "100%",
                        }}
                      />
                    </Grid>
                  </Grid>
                  {accountSummaryData?.map((item, index) => (
                    <Box
                      className="box-container dashboard-container"
                      key={index}
                    >
                      <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Typography className="insidePageLable">
                            Borrower name
                          </Typography>
                          <Typography className="insidePageValue">
                            {item.borrowerName}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Typography className="insidePageLable">
                            Co-Borrower
                          </Typography>
                          <Tooltip
                            arrow
                            enterTouchDelay={50}
                            title={
                              <React.Fragment>
                                {item?.coBorrowerName?.map((cb: CoBorrower) => (
                                  <div key={cb.cif}>
                                    <Typography variant="subtitle2">
                                      {cb.shortName}
                                    </Typography>
                                  </div>
                                ))}
                              </React.Fragment>
                            }
                            placement="top"
                            PopperProps={{
                              style: { transformOrigin: "center top" },
                              placement: "top-start",
                            }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: "common.white",
                                  "& .MuiTooltip-arrow": {
                                    color: "common.white",
                                  },
                                  color: "#808080",
                                  fontSize: "16px",
                                  fontWeight: "400",
                                  width: "500px",
                                  boxShadow: "-24px -12px 59px 0px #0000001A",
                                  border: "1px solid #E6E6E6",
                                },
                              },
                            }}
                          >
                            <div>
                              {item?.coBorrowerName
                                ?.slice(0, 3)
                                ?.map((value: CoBorrower, i: number) => (
                                  <span
                                    key={value.cif}
                                    className="insidePageValue"
                                  >
                                    {value.shortName}
                                    {i < 2 &&
                                      i !==
                                      item?.coBorrowerName?.slice(0, 3)
                                        .length -
                                      1 &&
                                      ","}
                                  </span>
                                ))}
                              {item?.coBorrowerName?.length > 3 && (
                                <span className="insidePageValue">
                                  {" ..."}
                                </span>
                              )}
                            </div>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}

                  <Grid container sm className="dashboard-container">
                    <Grid item xs={12} sm={7} md={7} lg={7}>
                      <Grid container spacing={spacing}>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <Typography className="insidePageLable">
                            Loan Amount
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatIndianRupees(
                              accountSummaryData[0]?.loanAmount
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <Typography className="insidePageLable">
                            Loan Tenure (Months)
                          </Typography>
                          <Typography className="insidePageValue">
                            {accountSummaryData[0]?.loanTenure}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <Typography className="insidePageLable">
                            Interest Rate Type
                            {/* {moratStatus && (
                              <Tooltip
                                placement="top"
                                title={"EMI Amount post Moratorium"}
                              >
                                <img
                                  src={InfoIcon}
                                  alt="Status"
                                  className="imgicon"
                                />
                              </Tooltip>
                            )} */}
                          </Typography>

                          <Typography className="insidePageValue">
                            {accountSummaryData[0]?.interestRateType ?? "-"}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={spacing}>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <Typography className="insidePageLable">
                            Grace Period (Months)
                          </Typography>
                          <Typography className="insidePageValue">
                            {accountSummaryData[0]?.gracePeriod}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <Typography className="insidePageLable">
                            Paid Principal Amount
                          </Typography>
                          <Typography className="insidePageValue">
                            {String(
                              formatIndianRupees(
                                accountSummaryData[0]?.totalDisbursementAmount
                              )
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} lg={4}>
                          <Typography className="insidePageLable">
                            Sanction Amount
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatIndianRupees(
                              accountSummaryData[0]?.sanctionedAmount
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={5} md={5} lg={5}>
                      <div style={{ display: "flex" }}>
                        {!isXsOrSm && (
                          <div className="line-container">
                            <div className="line vertical"></div>

                            <div className="line vertical"></div>
                          </div>
                        )}
                        <Grid container sm className="muiLinearProgress">
                          {/* Utilised Section */}
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            className="right-border"
                          >
                            <Typography className="mainHeadingLable muiLinear-progress-p">
                              <img
                                src={UtilizedIcon}
                                alt="Available"
                                style={{
                                  height: "22px",
                                }}
                              />
                              <span className="left-side-span">
                                Disbursed Amount
                              </span>{" "}
                            </Typography>
                            <Typography className="mainHeadingValue">
                              {formatIndianRupees(
                                accountSummaryData[0]?.loanAmount
                              )}
                            </Typography>
                            {/* Calculate and display the dynamic percentage */}
                            <Typography className="mainHeadingPerValue">
                              {handlePercentAmount(
                                accountSummaryData[0]?.loanAmount,
                                accountSummaryData[0]?.repayAmount,
                                "disburse"
                              )}
                              % used
                            </Typography>
                          </Grid>

                          {/* Available Section */}
                          <Grid item xs={6} sm={6} md={6} lg={6}>
                            <Typography
                              className="mainHeadingLable"
                              style={{ textAlign: "right" }}
                            >
                              <span className="mainHeadingLableSpan">
                                Sanctioned Amount
                              </span>
                              <img
                                src={AvailableIcon}
                                alt="Available"
                                style={{
                                  height: "22px",
                                }}
                              />
                            </Typography>

                            <div className="muiLinear-progress-div">
                              <Typography className="mainHeadingValue text-align-right mainHeadingValueRight">
                                {formatIndianRupees(
                                  accountSummaryData[0]?.repayAmount
                                )}
                              </Typography>
                              {/* Calculate and display the dynamic percentage */}
                              <Typography className="mainHeadingPerValue text-align-right">
                                {handlePercentAmount(
                                  accountSummaryData[0]?.loanAmount,
                                  accountSummaryData[0]?.repayAmount,
                                  "sanction"
                                )}
                                % left
                              </Typography>
                            </div>
                          </Grid>

                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box sx={{ width: "100%", marginTop: 3 }}>
                              <MultiColorProgressBar
                                variant="determinate"
                                value={parseInt(
                                  checkPercentage(accountSummaryData[0])
                                )}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </>
              )}
              {isXsOrSm && (
                <>
                  <Grid container className="active-button-container ">
                    <Grid item xs={9} sm={9} md={7} lg={8}>
                      <Box sx={{ float: "left" }}>
                        <AccountSelectorDropDown
                          labelText="Loan account number"
                          buttonText=" N/A"
                          isActive={""}
                          backgroundColor="transparent"
                          borderWidth="0px"
                          marginTop="0px"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={3} sm={3} md={5} lg={5}>
                      <Typography
                        className="active-button-mobile"
                        style={{
                          color:
                            accountSummaryData[0]?.status === "A"
                              ? "#28C76F"
                              : "#EA5455",
                          backgroundColor:
                            accountSummaryData[0]?.status === "A"
                              ? "#28C76F29"
                              : "#EA545529",
                        }}
                      >
                        {accountSummaryData[0]?.status === "A"
                          ? "Active"
                          : "Closed"}
                      </Typography>
                    </Grid>
                    <Divider
                      sx={{
                        border: isXsOrSm
                          ? ""
                          : "1px solid rgba(219, 218, 222, 1)",
                        borderColor: isXsOrSm ? "rgba(0, 0, 0, 0.12)" : "",
                        borderBottomWidth: isXsOrSm ? "thin" : "",
                        width: "100%",
                        marginTop: "6px",
                      }}
                    />
                  </Grid>
                  {accountSummaryData?.map((item, index) => (
                    <Box
                      className="box-container dashboard-container mb-20 dashboard-container-mobile"
                      key={index}
                    >
                      <Grid container>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <Typography className="insidePageLable">
                            Borrower name
                          </Typography>
                          <Typography className="insidePageValueMobile">
                            {item.borrowerName}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <Typography className="insidePageLable">
                            Co-Borrower
                          </Typography>
                          <Tooltip
                            arrow
                            title={
                              <React.Fragment>
                                {item?.coBorrowerName?.map((cb: CoBorrower) => (
                                  <div key={cb.cif}>
                                    <Typography variant="subtitle2">
                                      {cb.shortName}
                                    </Typography>
                                  </div>
                                ))}
                              </React.Fragment>
                            }
                            placement="top"
                            PopperProps={{
                              style: { transformOrigin: "center top" },
                              placement: "top-start",
                            }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: "common.white",
                                  "& .MuiTooltip-arrow": {
                                    color: "common.white",
                                  },
                                  color: "#808080",
                                  fontSize: "16px",
                                  fontWeight: "400",
                                  width: "500px",
                                  boxShadow: "-24px -12px 59px 0px #0000001A",
                                  border: "1px solid #E6E6E6",
                                },
                              },
                            }}
                          >
                            <div>
                              {item?.coBorrowerName
                                ?.slice(0, 3)
                                ?.map((value: CoBorrower, i: number) => (
                                  <span
                                    key={value.cif}
                                    className="insidePageValueMobile"
                                  >
                                    {value.shortName}
                                    {i < 2 &&
                                      i !==
                                      item?.coBorrowerName?.slice(0, 3)
                                        .length -
                                      1 &&
                                      ","}
                                  </span>
                                ))}
                              {item?.coBorrowerName?.length > 3 && (
                                <span className="insidePageValueMobile">
                                  {" ..."}
                                </span>
                              )}
                            </div>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </>
              )}
              {isXsOrSm && (
                <Grid container sm className="mt-20">
                  <Grid item xs={12} sm={5} md={5} lg={5} className="mb-20">
                    <div style={{ display: "flex" }}>
                      {!isXsOrSm && (
                        <div className="line-container">
                          <div className="line vertical"></div>
                          <div className="line vertical"></div>
                        </div>
                      )}
                      <Grid container sm className="muiLinearProgress">
                        {/* Utilised Section */}
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={6}
                          lg={6}
                          className="right-border"
                        >
                          <Typography className="mainHeadingLable muiLinear-progress-p">
                            <img
                              src={UtilizedIcon}
                              alt="Available"
                              style={{
                                height: "22px",
                              }}
                            />
                            <span className="left-side-span">
                              Disbursed Amount
                            </span>
                          </Typography>
                          <Typography className="mainHeadingValueMobile">
                            {formatIndianRupees(
                              accountSummaryData[0]?.loanAmount
                            )}
                          </Typography>
                          {/* Calculate and display the dynamic percentage */}
                          <Typography className="mainHeadingPerValueMobile">
                            {handlePercentAmount(
                              accountSummaryData[0]?.loanAmount,
                              accountSummaryData[0]?.repayAmount,
                              "disburse"
                            )}
                            % used
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <Typography className="mainHeadingLable  text-align-right">
                            <span className="right-side-span">
                              Sanctioned Amount
                            </span>
                            <img
                              src={AvailableIcon}
                              alt="Available"
                              style={{
                                height: "22px",
                              }}
                            />
                          </Typography>
                          <Typography className="mainHeadingValueMobile text-align-right mainHeadingValueMobileRight">
                            {formatIndianRupees(
                              accountSummaryData[0]?.repayAmount
                            )}
                          </Typography>
                          {/* Calculate and display the dynamic percentage */}
                          <Typography className="mainHeadingPerValueMobile text-align-right">
                            {handlePercentAmount(
                              accountSummaryData[0]?.loanAmount,
                              accountSummaryData[0]?.repayAmount,
                              "sanction"
                            )}
                            % left
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Box sx={{ width: "100%", marginTop: 1 }}>
                            <MultiColorProgressBarMobile
                              variant="determinate"
                              value={parseInt(
                                checkPercentage(accountSummaryData[0])
                              )} // Dynamic percentage
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={7}
                    md={7}
                    lg={7}
                    className="dashboard-container-mobile"
                  >
                    <Grid container spacing={spacing}>
                      <Grid item xs={4} sm={4} md={4} lg={4}>
                        <Typography className="insidePageLableMobile">
                          Loan Amount
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className="insidePageValueMobile"
                        >
                          {formatIndianRupees(
                            accountSummaryData[0]?.loanAmount
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} lg={4}>
                        <Typography className="insidePageLableMobile">
                          Loan Tenure (Months)
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className="insidePageValueMobile"
                        >
                          {accountSummaryData[0]?.loanTenure}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} lg={4}>
                        <Typography
                          className="insidePageLableMobile"
                          style={{ marginTop: "2px" }}
                        >
                          Interest Rate Type
                          {/* {moratStatus && (
                            <Tooltip
                              enterTouchDelay={50}
                              placement="top"
                              title={"EMI Amount post Moratorium"}
                            >
                              <img
                                src={InfoIcon}
                                alt="Status"
                                className="imgicon"
                              />
                            </Tooltip>
                          )} */}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className="insidePageValueMobile"
                        >
                          {accountSummaryData[0]?.interestRateType ?? "-"}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={spacing} mt={1}>
                      <Grid item xs={4} sm={4} md={4} lg={4}>
                        <Typography className="insidePageLableMobile">
                          Grace Period (Months)
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className="insidePageValueMobile"
                        >
                          {accountSummaryData[0]?.gracePeriod}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} lg={4}>
                        <Typography className="insidePageLableMobile">
                          Paid Principal Amount
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className="insidePageValueMobile"
                        >
                          {formatIndianRupees(
                            accountSummaryData[0]?.totalDisbursementAmount
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} lg={4}>
                        <Typography className="insidePageLableMobile">
                          Sanction Amount
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className="insidePageValueMobile"
                        >
                          {formatIndianRupees(
                            accountSummaryData[0]?.sanctionedAmount
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container sm className="mt-20"></Grid>
                </Grid>
              )}
            </Card>

            <Card marginBottom="20px">
              <Typography className="mb-20 section-heading">
                Loan Details
              </Typography>
              <Grid
                container
                sm
                className="dashboard-container"
                style={{ background: "transparent" }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {isXsOrSm && 
                  <>
                    <Grid container spacing={spacing}>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Total Interest Outstanding
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.totalPrincipalAmountPaid
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Total Principal Outstanding
                            <Tooltip
                            placement="top"
                            title={"Principal Outstanding Amount After Moratorium End (If Applicable)"}
                            enterTouchDelay={50}
                            sx={{ verticalAlign: "middle" }}
                          >
                            <img
                            src={InfoIcon}
                            alt="Status"
                            className="imgicon"
                            style={{ marginLeft: 6, verticalAlign: "middle",marginTop:"5px" }}
                            />
                          </Tooltip>
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.totalPrincipalOutstanding
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={spacing}>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Loan Start Date
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatDate(accountSummaryData[0]?.loanStartDate)}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Next Repay Amount
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.nextRepaymentAmount
                          )}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={spacing}>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Total Loan Outstanding
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.totalLoanOutstanding
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Loan End Date
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatDate(accountSummaryData[0]?.loanEndDate)}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={spacing}>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Remaining Tenure(Months)
                        </Typography>
                        <Typography className="insidePageValue">
                          {accountSummaryData[0]?.remainingTenure}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Next Repay Date
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatDate(accountSummaryData[0]?.nextRepaymentDate)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>}
                  {!isXsOrSm && 
                  <>
                    <Grid container spacing={spacing}>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Total Interest Outstanding
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.totalPrincipalAmountPaid
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Total Principal Outstanding
                           <Tooltip
                            placement="top"
                            title={"Principal Outstanding Amount After Moratorium End (If Applicable)"}
                            enterTouchDelay={50}
                            sx={{ verticalAlign: "middle" }}
                          >
                            <img
                            src={InfoIcon}
                            alt="Status"
                            className="imgicon"
                            style={{ marginLeft: 6, verticalAlign: "middle",marginTop:"5px" }}
                            />
                          </Tooltip>
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.totalPrincipalOutstanding
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Loan Start Date
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatDate(accountSummaryData[0]?.loanStartDate)}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Next Repay Amount
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.nextRepaymentAmount
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Total Loan Outstanding
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatIndianRupees(
                            accountSummaryData[0]?.totalLoanOutstanding
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Loan End Date
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatDate(accountSummaryData[0]?.loanEndDate)}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Remaining Tenure(Months)
                        </Typography>
                        <Typography className="insidePageValue">
                          {accountSummaryData[0]?.remainingTenure}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={3} lg={3}>
                        <Typography className="insidePageLable">
                          Next Repay Date
                        </Typography>
                        <Typography className="insidePageValue">
                          {formatDate(accountSummaryData[0]?.nextRepaymentDate)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>}
                </Grid>
              </Grid>
            </Card>
            <Card>
              <Typography className="mb-20 section-heading">
                Last Disbursement Details
              </Typography>
              <Grid
                container
                sm
                className="dashboard-container"
                style={{ background: "transparent" }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {isXsOrSm && <>
                  <Grid container spacing={spacing}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Beneficiary name
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.beneficiaryName}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Account number
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.accountNumber}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={spacing}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Bank Name
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.bankName}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        IFSC code
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.ifscCode}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={spacing}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Disbursement Amount
                      </Typography>
                      <Typography className="insidePageValue">
                        {formatIndianRupees(
                          accountSummaryData[0]?.disbursementAmount
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Disbursement Date
                      </Typography>
                      <Typography className="insidePageValue">
                        {formatDate(accountSummaryData[0]?.disbursementDate)}
                      </Typography>
                    </Grid>
                  </Grid></>}
                  {!isXsOrSm && <>
                  <Grid container spacing={spacing}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Beneficiary name
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.beneficiaryName}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Account number
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.accountNumber}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Bank Name
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.bankName}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        IFSC code
                      </Typography>
                      <Typography className="insidePageValue">
                        {accountSummaryData[0]?.ifscCode}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Disbursement Amount
                      </Typography>
                      <Typography className="insidePageValue">
                        {formatIndianRupees(
                          accountSummaryData[0]?.disbursementAmount
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">
                        Disbursement Date
                      </Typography>
                      <Typography className="insidePageValue">
                        {formatDate(accountSummaryData[0]?.disbursementDate)}
                      </Typography>
                    </Grid>
                  </Grid></>}
                </Grid>
              </Grid>
            </Card>
          </>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default AccountSummaryTerm;
